module.exports = __webpack_public_path__ + "img/game_jdb.7036760f.png";